export const LOGIN_TEMPLATE = `
<div class="bg-background-light dark:bg-background-dark min-h-screen flex flex-col">
  <div class="flex-grow flex items-center justify-center px-4 py-12">
    <div class="max-w-[440px] w-full">
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center p-3 bg-primary/10 rounded-xl mb-4">
          <span class="material-symbols-outlined text-primary text-4xl">motorcycle</span>
        </div>
        <h1 class="text-3xl font-bold text-slate-900 dark:text-white tracking-tight">MotoJourney Admin</h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2">Sign in to manage your journeys</p>
      </div>

      <div id="login-error" class="mb-6 animate-in fade-in slide-in-from-top-2 duration-300 hidden">
        <div class="flex items-center gap-3 p-4 rounded-lg bg-red-50 border border-red-200 text-red-800 dark:bg-red-900/20 dark:border-red-800/50 dark:text-red-400">
          <span class="material-symbols-outlined text-xl">error</span>
          <p id="login-error-message" class="text-sm font-medium">Invalid email or password</p>
          <button id="login-error-close" class="ml-auto hover:bg-red-100 dark:hover:bg-red-800/30 rounded p-1 flex items-center" type="button">
            <span class="material-symbols-outlined text-lg">close</span>
          </button>
        </div>
      </div>

      <div class="bg-white dark:bg-slate-900 shadow-xl shadow-slate-200/50 dark:shadow-none border border-slate-200 dark:border-slate-800 rounded-xl p-8">
        <form id="login-form" action="#" class="space-y-5" method="POST" novalidate>
          <div>
            <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1.5" for="email">Email Address</label>
            <div class="relative">
              <input class="w-full h-12 px-4 rounded-lg border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50 text-slate-900 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all placeholder:text-slate-400" id="email" placeholder="name@company.com" type="email" value="" autocomplete="email"/>
              <div id="email-error-icon" class="absolute inset-y-0 right-0 pr-3 items-center pointer-events-none hidden">
                <span class="material-symbols-outlined text-red-500 text-xl">warning</span>
              </div>
            </div>
            <p id="email-error" class="mt-1.5 text-xs font-medium text-red-600 dark:text-red-400 flex items-center gap-1 hidden"></p>
          </div>

          <div>
            <div class="flex items-center justify-between mb-1.5">
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300" for="password">Password</label>
              <a class="text-xs font-semibold text-primary hover:text-primary/80 transition-colors" href="#">Forgot password?</a>
            </div>
            <div class="relative">
              <input class="w-full h-12 px-4 rounded-lg border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50 text-slate-900 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all" id="password" placeholder="••••••••" type="password" autocomplete="current-password"/>
              <button id="password-toggle" class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-300" type="button">
                <span id="password-toggle-icon" class="material-symbols-outlined text-xl">visibility</span>
              </button>
            </div>
            <p id="password-error" class="mt-1.5 text-xs font-medium text-red-600 dark:text-red-400 hidden"></p>
          </div>

          <div class="flex items-center">
            <input class="h-4 w-4 rounded border-slate-300 text-primary focus:ring-primary cursor-pointer" id="remember-me" name="remember-me" type="checkbox"/>
            <label class="ml-2 block text-sm text-slate-600 dark:text-slate-400 cursor-pointer" for="remember-me">
              Keep me signed in
            </label>
          </div>

          <button id="login-submit" class="w-full bg-primary hover:bg-primary/90 text-white font-bold h-12 rounded-lg transition-all flex items-center justify-center gap-2 active:scale-[0.98] shadow-lg shadow-primary/20 disabled:cursor-not-allowed disabled:bg-primary/70" type="submit">
            <svg id="login-spinner" class="animate-spin h-5 w-5 text-white hidden" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor"></path>
            </svg>
            <span id="login-submit-label">Sign In</span>
          </button>

          <div class="text-center pt-2">
            <p class="text-[11px] text-slate-400 dark:text-slate-500 flex items-center justify-center gap-1">
              <span class="material-symbols-outlined text-[14px]">shield</span>
              Authorized staff only. Unauthorized access is prohibited.
            </p>
          </div>
        </form>
      </div>

      <footer class="mt-8 text-center space-y-4">
        <div class="flex items-center justify-center gap-6">
          <a class="text-sm font-medium text-slate-500 hover:text-primary transition-colors flex items-center gap-1" href="#">
            <span class="material-symbols-outlined text-lg">arrow_back</span>
            Back to main site
          </a>
          <span class="h-1 w-1 rounded-full bg-slate-300"></span>
          <p class="text-sm text-slate-500">© 2024 MotoJourney</p>
        </div>
      </footer>
    </div>
  </div>

  <div class="fixed top-0 left-0 w-full h-full -z-10 overflow-hidden pointer-events-none opacity-40">
    <div class="absolute -top-[10%] -right-[5%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[120px]"></div>
    <div class="absolute -bottom-[10%] -left-[5%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[120px]"></div>
  </div>
</div>
`;
